import { Box } from "@mui/material";
import { CanvasViewer } from "../common/canvas/CanvasViewer";
import { useParams } from "react-router-dom";
import { useCanvasData } from "../../hooks/useCanvasData";

export const PuzzleViewer = () => {
  const param = useParams<{ id: string }>();
  const canvasData = useCanvasData(param.id);
  if (!param.id) return <>urlが不正です</>;
  if (!canvasData.isCanvasDataLoaded) return <>読み込み中</>;
  if (!canvasData.canvasData) return <>データがありません</>;

  return (
    <Box sx={{ m: "auto" }}>
      <CanvasViewer
        canvasData={canvasData.canvasData}
        maxWidth={600}
        imageUrl={`https://firebasestorage.googleapis.com/v0/b/puzzlepentool.appspot.com/o/yajilin.png?alt=media&token=fbdc1dda-5235-43c2-afa0-3e15c0f02a0c`}
      />
    </Box>
  );
};
